import { lazy } from '@/service/lazy'

export default [{
  name: 'Links Úteis',
  path: 'links',
  id: 'links',
  icon: 'fa fa-link',
  component: lazy('app/default/gerenciador/link/index'),
  meta: { requireAuth: true, rules: ['gerenciar_links'] },
  children: []
}]



// WEBPACK FOOTER //
// ./src/router/modules/default/link.js